import { notification } from 'antd'
import { AuthTokenService } from '../services'

export default (username, password, t) => {
  return new Promise((resolve, reject) => {
    AuthTokenService.create(username, password, new Date().getTime())
      .then(async response => {
        if(response) {
          if (response.data.code === 200) {
            resolve({
              token: response.data.token,
              expirationDate: response.data.expirationDate
            })
          } else {
            switch(response.data.msg) {
              case 'INVALID_CREDENTIALS':
              case 'USER_DISABLED':
                notification['error']({ message: t('messages.aml.login.usererror') })
                resolve({ error: true })
                break

              case 'USER_LOCKED':
                notification['error']({ message: t('messages.aml.login.userlocked') })
                resolve({ error: true })
                break

              case 'IP_NOT_AUTHORIZED':
                notification['error']({ message: t('messages.aml.login.ipnotAllowed') })
                resolve({ error: true })
                break

              case 'PASSWORD_EXPIRED':
                notification['error']({ message: t('messages.aml.login.expiredPassword') })
                resolve({ error: true })
                break

              default:
                notification['error']({ message: t('messages.aml.login.unknownError') })
                resolve({ error: true })
                break
            }
          }
        }
      })
      .catch(error => {
          notification['error']({ message: t('messages.aml.login.unknownError') })
          resolve({ error: true })
      })
  })
}
